import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'
import { ReactElement } from 'react'
import { TableEmptyState } from 'app/components/ui/table-empty-state'

/**
 * Empty state for a live list whose query failed, so a failure never reads as "nothing to
 * see". Says nothing about the error itself: the store logs it, and ops errors can carry
 * internal detail.
 */
export function ListErrorState({ subject }: { subject: string }): ReactElement {
  return (
    <TableEmptyState
      icon={<ExclamationTriangleIcon className="h-6 w-6" />}
      title={`Couldn't load ${subject}`}
      description="The query failed, so this list may not be empty. Reload the page to try again."
    />
  )
}
